import React from "react";
import { fileUrl } from "@/lib/api";

/** Circular avatar with optional ring for special tiers/badges. */
export default function Avatar({ user = {}, src, name, size = 40, className = "" }) {
  const u = user || {};
  const role = u.role;
  const badges = u.badges || [];
  const finalSrc = src || u.avatar_url;
  const finalName = name || u.name || u.email || "U";
  let ring = "";
  // Founder takes precedence over everything (highest rank)
  if (role === "admin") ring = "ring-founder";
  else if (badges.includes("cult_master")) ring = "ring-cult-master";
  else if (badges.includes("top_1_supporter")) ring = "ring-top1";
  else if (badges.includes("top_2_supporter")) ring = "ring-top2";
  else if (badges.includes("top_3_supporter")) ring = "ring-top3";
  else if (role === "god_tier_supporter") ring = "ring-god";

  const style = { width: size, height: size, fontSize: Math.max(10, size * 0.4) };
  const initial = (finalName || "U")[0]?.toUpperCase() || "U";
  return (
    <span className={`avatar-frame ${ring} ${className}`} style={style}>
      {finalSrc ? (
        <img src={fileUrl(finalSrc)} alt={finalName} />
      ) : (
        <span>{initial}</span>
      )}
    </span>
  );
}
